export default function Footer() {
    return (
    <div style={{position: "relative", paddingLeft: "4vw", paddingRight: "2vw", bottom: "0px"}}>
        <h4>© 2022 RTfilmhouse</h4>
      </div>
    );
  }